import { Link } from "react-router-dom";
import type { Anime } from "@/types";

interface AnimeCardProps {
  anime: Anime;
  showSummary?: boolean;
}

export default function AnimeCard({ anime, showSummary = true }: AnimeCardProps) {
  return (
    <Link
      to={`/anime/detail/${anime.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-all duration-300 cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={anime.cover}
          alt={`${anime.title} 动漫封面`}
          title={`${anime.title} - 51动漫`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-full bg-foreground-950/70 text-background-50 text-[11px] font-medium">
          {anime.status}
        </span>
        <span className="absolute top-2 right-2 px-2 py-0.5 rounded-full bg-accent-500 text-background-50 text-[11px] font-semibold flex items-center gap-0.5">
          <i className="ri-star-fill text-[10px]"></i>
          {anime.rating.toFixed(1)}
        </span>
      </div>
      <div className="p-3">
        <h3 className="font-heading font-semibold text-sm text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
          {anime.title}
        </h3>
        <div className="mt-1.5 flex items-center flex-wrap gap-x-2 gap-y-1 text-[11px] text-foreground-500">
          <span className="px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-900">
            {anime.type}
          </span>
          <span>{anime.year}</span>
          <span>·</span>
          <span>{anime.region}</span>
        </div>
        {showSummary && (
          <p className="mt-2 text-xs leading-relaxed text-foreground-600 line-clamp-2">
            {anime.summary}
          </p>
        )}
        <div className="mt-2 text-[11px] text-primary-600 font-medium">
          更新至第 {anime.episodes} 集 / 共 {anime.totalEpisodes} 集
        </div>
      </div>
    </Link>
  );
}